import React from 'react';

import Section from '../../components/Section/Section';
import Button from '../../components/Button/Button';
import Heading from '../../components/Heading/Heading';
import CountUp from 'react-countup';

import styles from './Display.module.scss';

const Results = ({ newGame, players }) => {
  const resultList = players
    .sort((a, b) => {
      if (a.score > b.score) {
        return -1;
      }
      return 1;
    })
    .map((player) => {
      return (
        <div key={player.uid} className={styles.entry}>
          <div className={styles.name}>{player.name}</div>
          <div className={styles.score}>
            <CountUp end={player.score} start={0} duration={1} /> pts
          </div>
        </div>
      );
    });

  return (
    <Section className={styles.result}>
      <Heading className={styles.title}>Highscore</Heading>
      <div className={styles.highscore}>{resultList}</div>
      <Button onClick={newGame}>New game</Button>
    </Section>
  );
};

export default Results;
